<template>
<svg viewBox="0 0 34 35" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-ShouYeWeiXuanZhong2`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.4519 6.79996L7.65427 12.4449C6.61515 13.1972 5.99988 14.4022 5.99988 15.685V24.7104C5.99988 26.9196 7.79074 28.7104 9.99988 28.7104H14.2994V21.5743C14.2994 21.022 14.7472 20.5743 15.2994 20.5743H16.7589C18.9681 20.5743 20.7589 22.3651 20.7589 24.5743V28.7104H25.0757C27.2848 28.7104 29.0757 26.9196 29.0757 24.7104V15.6169C29.0757 14.3724 28.4964 13.1988 27.5086 12.4418L20.2304 6.86497C18.827 5.78961 16.884 5.76318 15.4519 6.79996Z"/></svg>
</template>
<script>

export default {
  name: 'IconShouYeWeiXuanZhong2',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
